module.exports = __webpack_public_path__ + "img/router.5c089917.svg";